import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {ImportUsersDialogComponent} from './import.users.dialog.component';


const routes =
    [{path: 'importusersdialog', component: ImportUsersDialogComponent}];

@NgModule({
  declarations: [ImportUsersDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [ImportUsersDialogComponent]
})

export class ImportUsersModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/import/import.users.dialog.module.ts